import { Component, OnInit } from "@angular/core";

import { MatDialog, MatDialogConfig } from "@angular/material";
import { HistorialService } from "src/app/services/historial.service";
import Swal from "sweetalert2";
import { DialogprehistorialComponent } from "../dialogprehistorial/dialogprehistorial.component";
import { DialograngofechasComponent } from "../dialograngofechas/dialograngofechas.component";



@Component({
  selector: "app-utilerias",
  templateUrl: "./utilerias.component.html",
  styleUrls: ["./utilerias.component.css"],
})

export class UtileriasComponent implements OnInit {

  folioinicial="";
  

  constructor(public dialog: MatDialog,
     private historialService : HistorialService  ) {
   
  }

  ngOnInit() {}


  historialRegistro() { 
    this.openDialogPrehistorial();


    

  }

  borrarRegistro() {
    this.openDialog();
  }

 


  

//   dialogConfig.data = {
//     id: 1,
//     title: 'Angular For Beginners'
// };


openDialogPrehistorial() {
    //esto es para configurar la ventana de dialogo
    const dialogConfig = new MatDialogConfig();

      dialogConfig.disableClose = true; // esta opcion inpide que la tecla esc desactive la ventana emergente
      dialogConfig.autoFocus = true;
      dialogConfig.width='350px';
      dialogConfig.data= 'Seleccione el Rango de Fechas a Borrar?'  // esto es para trasnferir dtoa a dialog

    const dialogRef = this.dialog.open(DialogprehistorialComponent ,dialogConfig);
    dialogRef.afterClosed().subscribe((res) => {
      if (res) {

        // let fechainicial= moment(res.date._d).format("yyyy-MM-DD");
        // var fechafinal= moment(res.serializedDate._d).format("yyyy-MM-DD");



      this.historialService.getborraHistorial(res.date._d , res.serializedDate._d)
      .subscribe (resp=>{
        console.log (resp)
      })
      }
      
    });
  
}


  openDialog() {

    //esto es para configurar la ventana de dialogo
    const dialogConfig = new MatDialogConfig();

      dialogConfig.disableClose = true; // esta opcion inpide que la tecla esc desactive la ventana emergente
      dialogConfig.autoFocus = true;
      dialogConfig.width='350px';
      dialogConfig.data= 'Seleccione el Rango de Fechas a Borrar?'  // esto es para trasnferir dtoa a dialog

    const dialogRef = this.dialog.open(DialograngofechasComponent ,dialogConfig);
    dialogRef.afterClosed().subscribe((res) => {
      if (res) {

        // let fechainicial= moment(res.date._d).format("yyyy-MM-DD");
        // var fechafinal= moment(res.serializedDate._d).format("yyyy-MM-DD");



      this.historialService.getborraHistorial(res.date._d , res.serializedDate._d)
      .subscribe (resp=>{
        console.log (resp)
      })
      }
      
    });
  }
}

